import { Component } from '@angular/core';
import { ChartOfAccountsService } from '../chart-of-accounts.service';
import { ChartOfAccounts } from '../chart-of-accounts';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-chart-of-accounts-edit',
  templateUrl: 'edit.component.html',
})
export class ChartOfAccountsEditComponent {
  /**
   * Details of the chartOfAccounts being edited.
   */
  public chartOfAccounts: ChartOfAccounts;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ChartOfAccountsService} chartOfAccountsService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private chartOfAccountsService: ChartOfAccountsService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.chartOfAccountsService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadChartOfAccounts(params.id));
  }

  /**
   * Perform the edit action which send the edited chartOfAccounts to the backend.
   */
  public edit() {
    const editChartOfAccounts = this.chartOfAccountsService
      .updateChartOfAccounts(this.chartOfAccounts.id, this.chartOfAccounts)
      .subscribe(
        (result: ChartOfAccounts) => {
          this.notificationService.success(
            `Delivery Method Updated`,
            `The delivery Method ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.chartOfAccounts = new ChartOfAccounts();
          editChartOfAccounts.unsubscribe();
          this.router.navigate(['/chart-of-accounts']);
        },
        err => {
          this.notificationService.error(
            `Delivery Method Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/chart-of-accounts']);
        },
      );
  }

  /**
   * Loads the requested chartOfAccounts so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadChartOfAccounts(id: string) {
    this.chartOfAccountsService.findChartOfAccounts(id).subscribe(
      result => {
        this.chartOfAccounts = result;
      },
      err => {
        this.notificationService.error(
          `Delivery Method Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/chart-of-accounts']);
      },
    );
  }
}
